/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { schema3OtherResolveReferenceApiV1SandboxGithubRepositoriesResolvePost } from "../../funcs/schema3OtherResolveReferenceApiV1SandboxGithubRepositoriesResolvePost.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .ResolveReferenceApiV1SandboxGithubRepositoriesResolvePostRequest$inboundSchema,
};

export const tool$schema3OtherResolveReferenceApiV1SandboxGithubRepositoriesResolvePost:
  ToolDefinition<typeof args> = {
    name:
      "schema-3-other-resolve-reference-api-v1-sandbox-github-repositories-resolve-post",
    description: `Resolve Reference`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await schema3OtherResolveReferenceApiV1SandboxGithubRepositoriesResolvePost(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
